<h6 class="font-semibold mb-1">{{ '#UTILITIES.USER_CONTEXT.LABEL' | translate }}</h6>
<ng-container>
  <div class="flex flex-row justify-between">
    <span>{{ (userContext$ | async)?.userFullName }}</span>
  </div>
</ng-container>
